import { CreateAuthOrganizationCard } from "@components/Cards";

export const CreateAuthOrganization = () => {
  return <CreateAuthOrganizationCard />;
};
